export interface GalleryItem {
  id: number;
  title: string;
  subtitle: string;
  category: 'BULLION' | 'EMBROIDERY' | 'CUSTOM';
  bgColor: string;
  accentColor: string;
  year: string;
}

export const galleryItems: GalleryItem[] = [
  {
    id: 1,
    title: 'Golden Crest',
    subtitle: '금장 크레스트 엠블럼',
    category: 'BULLION',
    bgColor: '#2C2C2C',
    accentColor: '#C9A961',
    year: '2024',
  },
  {
    id: 2,
    title: 'Silk Rose',
    subtitle: '실크 장미 자수',
    category: 'EMBROIDERY',
    bgColor: '#3D3D3D',
    accentColor: '#E8D5A3',
    year: '2024',
  },
  {
    id: 3,
    title: 'Royal Wreath',
    subtitle: '왕실 월계관 엠블럼',
    category: 'BULLION',
    bgColor: '#1A1A1A',
    accentColor: '#C9A961',
    year: '2023',
  },
  {
    id: 4,
    title: 'Floral Motif',
    subtitle: '플로럴 모티프 자수',
    category: 'EMBROIDERY',
    bgColor: '#2C2C2C',
    accentColor: '#E8D5A3',
    year: '2023',
  },
  {
    id: 5,
    title: 'Military Badge',
    subtitle: '군 예복 배지',
    category: 'BULLION',
    bgColor: '#3D3D3D',
    accentColor: '#C9A961',
    year: '2024',
  },
  {
    id: 6,
    title: 'Brand Logo',
    subtitle: '브랜드 로고 맞춤 자수',
    category: 'CUSTOM',
    bgColor: '#1A1A1A',
    accentColor: '#E8D5A3',
    year: '2023',
  },
  {
    id: 7,
    title: 'Heraldic Lion',
    subtitle: '문장 사자 엠블럼',
    category: 'BULLION',
    bgColor: '#2C2C2C',
    accentColor: '#C9A961',
    year: '2024',
  },
  {
    id: 8,
    title: 'Botanical Series',
    subtitle: '보태니컬 시리즈 자수',
    category: 'EMBROIDERY',
    bgColor: '#3D3D3D',
    accentColor: '#E8D5A3',
    year: '2022',
  },
  {
    id: 9,
    title: 'Corporate Crest',
    subtitle: '기업 크레스트 제작',
    category: 'CUSTOM',
    bgColor: '#1A1A1A',
    accentColor: '#C9A961',
    year: '2023',
  },
  {
    id: 10,
    title: 'Renaissance',
    subtitle: '르네상스 태피스트리',
    category: 'EMBROIDERY',
    bgColor: '#2C2C2C',
    accentColor: '#E8D5A3',
    year: '2024',
  },
  {
    id: 11,
    title: 'Epaulette',
    subtitle: '에포렛 어깨 장식',
    category: 'BULLION',
    bgColor: '#3D3D3D',
    accentColor: '#C9A961',
    year: '2022',
  },
  {
    id: 12,
    title: 'Couture Detail',
    subtitle: '쿠튀르 의상 자수',
    category: 'CUSTOM',
    bgColor: '#1A1A1A',
    accentColor: '#E8D5A3',
    year: '2024',
  },
];
